type Props = {
  isVisible: boolean;
  placeholder?: string;
};

export function CommandEditorPlaceholder({ isVisible, placeholder }: Props) {
  return (
    <div
      className="monaco-placeholder"
      style={{
        display: isVisible ? "block" : "none",
        pointerEvents: "none",
        position: "absolute",
        top: "10px",
        left: "22px",
        color: "#999999",
        zIndex: "100000000",
        fontFamily: "monospace",
        fontSize: "14px",
      }}
    >
      {placeholder}
    </div>
  );
}
